<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="d-none d-md-block col-md-8 col-lg-6">
          <contact-phones class="text-left" :inline="true" />
        </div>
        <div class="col-md-4 col-lg-6">
          <p class="footer__legal my-0" v-html="legal_text"></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ContactPhones from '@/components/ContactPhones';

export default {
  name: 'AppFooter',
  components: {
    ContactPhones,
  },
  data() {
    return {
      legal_text: process.env.VUE_APP_BRAND_LEGAL,
    };
  },
};
</script>
